<template>
  <AppWithLoading :fetch="fetchData">
    <slot :plan="plan" />
  </AppWithLoading>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';
import usePlan from '@/compositions/accounting/usePlan';
import AppWithLoading from '@/components/AppWithLoading';

export default {
  name: 'PaymentPlanResolver',
  components: { AppWithLoading },
  props: {
    id: {
      type: Number,
      required: true,
    },
    fetch: {
      type: Function,
      default: null,
    },
  },
  setup(props) {
    const { id, fetch } = toRefs(props);
    const { getPlanById, fetchAll } = usePlan();
    const plan = computed(() => getPlanById(id.value));

    async function fetchData() {
      await fetchAll();
      if (typeof fetch.value !== 'function') {
        return;
      }
      await fetch.value(plan.value);
    }

    return {
      fetchData,
      plan,
    };
  },
};
</script>

<style scoped>

</style>
